import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFilePlus: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#25314C',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.53 8.47L14.53 2.47C14.389 2.329 14.199 2.25 14 2.25H8C5.582 2.25 4.25 3.582 4.25 6V18C4.25 20.418 5.582 21.75 8 21.75H17C19.418 21.75 20.75 20.418 20.75 18V9C20.75 8.801 20.671 8.61 20.53 8.47ZM14.75 4.811L18.189 8.25H17C15.423 8.25 14.75 7.577 14.75 6V4.811ZM17 20.25H8C6.423 20.25 5.75 19.577 5.75 18V6C5.75 4.423 6.423 3.75 8 3.75H13.25V6C13.25 8.418 14.582 9.75 17 9.75H19.25V18C19.25 19.577 18.577 20.25 17 20.25ZM15.75 14C15.75 14.414 15.414 14.75 15 14.75H13.25V16.5C13.25 16.914 12.914 17.25 12.5 17.25C12.086 17.25 11.75 16.914 11.75 16.5V14.75H10C9.586 14.75 9.25 14.414 9.25 14C9.25 13.586 9.586 13.25 10 13.25H11.75V11.5C11.75 11.086 12.086 10.75 12.5 10.75C12.914 10.75 13.25 11.086 13.25 11.5V13.25H15C15.414 13.25 15.75 13.586 15.75 14Z"
      fill={color}
    />
  </svg>
);

export default IconFilePlus;
